import { Box, Skeleton, Grid } from '@mui/material';

const BillingDetailsSkeleton = () => {
  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="text" width={200} height={32} sx={{ mb: 0.5 }} />
        <Skeleton variant="text" width="80%" height={20} />
      </Box>

      {/* Basic Information Section */}
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="text" width={150} height={28} sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          {/* Company Name */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>

          {/* Email */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width={80} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>

          {/* Phone Number */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width={100} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>

          {/* GST Number */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width={140} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Address Section */}
      <Box>
        <Skeleton variant="text" width={100} height={28} sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          {/* Street Address 1 */}
          <Grid item xs={12}>
            <Skeleton variant="text" width={130} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>

          {/* Street Address 2 */}
          <Grid item xs={12}>
            <Skeleton variant="text" width={180} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>

          {/* City */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width={60} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>

          {/* ZIP/Postal Code */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width={130} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>

          {/* Country */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width={80} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>

          {/* State */}
          <Grid item xs={12} md={6}>
            <Skeleton variant="text" width={60} height={20} sx={{ mb: 1 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={40}
              sx={{
                borderRadius: '6px',
                bgcolor: '#F8F9FC',
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default BillingDetailsSkeleton;
